$(function () {

	$("[data-gallery] [data-index]").on("click", function (e) {
		e.preventDefault();
		goToGalleryImage($(this).closest("[data-gallery]").attr("data-gallery"), $(this).attr("data-index"));
	});

	$("#galleryModal .gallery-control").on("click", function () {
		var id = $(this).closest("#galleryModal").attr("data-gallery-id");
		if ($(this).hasClass("left")) {
			goToPrev(id);
		}
		else {
			goToNext(id);
		}
	});

	function goToGalleryImage(id, index) {
		var gallery = $("[data-gallery='" + id + "']");
		console.log(gallery);
		if (gallery.length == 0) return;

		var modal = $("#galleryModal[data-gallery-id='" + id + "']");
		console.log(modal);
		if (modal.length == 0) return;

		index = parseInt("0" + index);
		console.log(index);

		modal.find("[data-gallery-image]").attr("src", gallery.find("[data-index='" + index + "']").attr("href"));
		modal.attr("data-gallery-index", index);

		var previous = gallery.find("[data-index='" + (index - 1) + "']");
		var next = gallery.find("[data-index='" + (index + 1) + "']");

		if (previous.length == 0) {
			previous = gallery.find(":last-child [data-index]");
		}
		if (next.length == 0) {
			next = gallery.find(":first-child [data-index]");
		}

		if ((modal.data('bs.modal') || {}).isShown) {

		}
		else {
			modal.modal("show");
		}
	}

	function goToNext(id) {

		var gallery = $("[data-gallery='" + id + "']");
		if (gallery.length == 0) return;

		var modal = $("#galleryModal[data-gallery-id='" + id + "'][data-gallery-index]");
		if (modal.length == 0) return;

		var index = parseInt("0" + modal.attr("data-gallery-index"));

		var next = gallery.find("[data-index='" + (index + 1) + "']");

		if (next.length == 0) {
			next = gallery.find(":first-child [data-index]");
		}

		goToGalleryImage(id, next.attr("data-index"));
	}


	function goToPrev(id) {

		var gallery = $("[data-gallery='" + id + "']");
		if (gallery.length == 0) return;

		var modal = $("#galleryModal[data-gallery-id='" + id + "'][data-gallery-index]");
		if (modal.length == 0) return;

		var index = parseInt("0" + modal.attr("data-gallery-index"));

		var previous = gallery.find("[data-index='" + (index - 1) + "']");

		if (previous.length == 0) {
			previous = gallery.find(":last-child [data-index]");
		}

		goToGalleryImage(id, previous.attr("data-index"));
	}
});